import { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import LoadingScreen from '../../components/loading/LoadingScreen';
import { useAuth } from '../../context/AuthContext';
import swal from '../../utils/swal';
import './Layout.css';

const LOADING_DURATION_MS = 850;

function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), LOADING_DURATION_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  async function handleLogout() {
    const result = await swal.fire({
      title: '¿Cerrar sesión?',
      text: 'Tu sesión actual se cerrará.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, salir',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      logout();
      navigate('/login');
    }
  }

  return (
    <div className="layout">
      {isLoading && <LoadingScreen />}
      <Header drawerOpen={drawerOpen} onMenuClick={() => setDrawerOpen(prev => !prev)} />
      <Sidebar
        drawerOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onLogout={handleLogout}
        userRole={user.rol}
      />
      <main className="layout__main">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
